/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import SearchBar from './SearchBar';
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
import { getProductParentList, getTypeList, getProductProductList } from '@/api';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    Group: Group,
    Cell: Cell,
    SearchBar: SearchBar,
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectCustomerId: {
      type: [String, Number],
      default: ''
    },
    isProductionFromcustomer: {
      type: Number,
      required: true
    },
    showMask: {
      type: Boolean,
      default: false
    },
    check: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      name: '',
      parentId: '',
      pageIndex: 0,
      pageSize: 10,
      productTypeList: [],
      productList: [],
      checkList: [],
      parentList: [],
      ids: []
    };
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - (4 + 4 + 0.8) * fontSize;
    }
  },
  watch: {
    parentId: function parentId(val) {
      this.pageIndex = 0;
      this.loadProductParentList();
      this.loadType();
      this.loadList(true);
    },
    value: function value(val) {
      this.currValue = val;
      if (val) {
        this.pageIndex = 0;
        this.loadList(true);
      } else {
        this.$refs.scrollerList.clearCheckList && this.$refs.scrollerList.clearCheckList();
      }
    },
    currValue: function currValue(val) {
      var _this = this;
      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this.currValue = false;
          }
        });
      } else {
        this.$setLeft({
          control: false
        });
      }
      this.$emit('input', val);
    },
    checkList: function checkList(val) {
      var _this2 = this;
      this.$emit('on-check', this.productList.filter(function (item) {
        return _this2.checkList.indexOf(item.id) !== -1;
      }));
      this.currValue = false;
    } // 回显
    // ids: {
    //   handler (val) {
    //     this.$refs['scrollerList'].checkList = val.slice()
    //   },
    //   immediate: true
    // }
  },
  methods: {
    replaceMultiImg: function replaceMultiImg(urls) {
      if (!urls) return '';
      var urlArr = urls.split(',');
      return urlArr[0];
    },
    // 单选产品
    getProduct: function getProduct(item) {
      if (!this.check) {
        this.$emit('on-check', item);
        this.currValue = false;
      }
    },
    // 产品类别父级
    loadProductParentList: function loadProductParentList() {
      var _this3 = this;
      getProductParentList({
        typeId: this.parentId
      }).then(function (res) {
        _this3.parentList = res.data;
      });
    },
    // 产品类别
    loadType: function loadType() {
      var _this4 = this;
      getTypeList({
        parentId: this.parentId
      }).then(function (res) {
        if (res.success) {
          _this4.productTypeList = res.data;
        } else {
          _this4.$vux.toast.text(res.message);
        }
      });
    },
    // 产品列表
    loadList: function loadList() {
      var _this5 = this;
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var form = {
        typeId: this.parentId,
        name: this.name
      };
      getProductProductList(_objectSpread({
        pageIndex: this.pageIndex++,
        pageSize: this.pageSize
      }, form)).then(function (res) {
        if (res.success) {
          var data = _this5.isProductionFromcustomer === 1 ? res.data : res.data.list;
          if (reset) {
            _this5.productList = data;
          } else {
            _this5.productList = _this5.productList.concat(data);
          }
          _this5.$refs['scrollerList'] && _this5.$refs['scrollerList'].donePulldown();
          if (data.length < _this5.pageSize) {
            _this5.$refs['scrollerList'] && _this5.$refs['scrollerList'].disablePullup();
          }
        } else {
          _this5.$vux.toast.text(res.message);
        }
      });
    },
    onPullupLoading: function onPullupLoading() {
      this.loadList();
    },
    onPulldownLoading: function onPulldownLoading() {
      this.productList = [];
      this.$refs['scrollerList'].enablePullup();
      this.pageIndex = 0;
      this.loadList();
    },
    changeParent: function changeParent(index, id) {
      if (index < this.parentList.length - 1) {
        this.parentId = id;
      }
    },
    search: function search() {
      this.pageIndex = 0;
      this.loadList(true);
    }
  },
  created: function created() {
    this.loadType();
    this.loadList();
  }
};